"use strict";
import m from 'mithril';

import 'scss/contact';

const displayRow = (name, oninput, placeholder, value) => {
    const id = name.toLowerCase().replace(/ /, '-');

    return m(
        'div',
        {class: 'row'},
        [
            m('label', {for: id}, name),
            m(
                'input',
                {
                    id: id,
                    oninput: oninput,
                    placeholder: placeholder,
                    type: 'text',
                    value: value
                }
            )
        ]
    );
};


export default {
    view: ({attrs}) => m(
        'section',
        {class: 'contact'},
        [
            m('h1', {}, 'Contact'),
            m(
                'div',
                {class: 'content'},
                attrs.serviceUnavailable ?
                    [
                        m(
                            'section',
                            {class: 'warning'},
                            [
                                m('h1', {}, 'Error'),
                                m(
                                    'p',
                                    {},
                                    `The email service is currently unavailable.  Please contact us directly at ${data.serviceEmail}. Sorry for the inconvenience.`
                                )
                            ]
                        )
                    ] :
                    (
                        attrs.messageSent ?
                            [

                                m('p', {class: 'message-sent'}, 'Thank you for your message.'),
                                m(
                                    'button',
                                    {
                                        class: 'send-another',
                                        onclick: () => {
                                            attrs.message = '';
                                            attrs.messageSent = false;
                                        }
                                    },
                                    'Send Another'
                                ),
                                m('div.clear')
                            ] :
                            [
                                displayRow('Company', (e) => attrs.company = e.target.value, 'Company Name', attrs.company),
                                displayRow('Name', (e) => attrs.name = e.target.value, 'Name', attrs.name),
                                displayRow('Email', (e) => attrs.email = e.target.value, 'Email', attrs.email),
                                m(
                                    'div',
                                    {class: 'row'},
                                    [
                                        m('label', {for: 'message'}, 'Message'),
                                        m(
                                            'textarea',
                                            {
                                                cols: 80,
                                                id: 'message',
                                                oninput: e => attrs.message = e.target.value,
                                                placeholder: 'Your message for Northpoint.',
                                                rows: 6,
                                            }
                                        )
                                    ]
                                ),
                                m(
                                    'div',
                                    {class: 'button-group right'},
                                    [
                                        m(
                                            'button',
                                            Object.assign(
                                                {
                                                    onclick: attrs.submit
                                                },
                                                attrs.message.length ?
                                                    {} :
                                                    {disabled: 'disabled'}
                                            ),
                                            'Submit')
                                    ]
                                ),
                                m('div', {class: 'clear'})
                            ]
                    )
            )
        ]
    )
}
;